import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CommonStructured from "../../common-components/CommonStructured";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AdminLeaveForm from "./AdminLeaveForm";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { fetchLeaveCategoriesData } from "../../../redux/reducers/apiSlice";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { deleteLeaveCategory } from "../../../data/ApiEndpoints";
import Loader from "../../ui/Loader";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const LeaveCategory = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const { loading, leaveCategories } = useSelector((state) => state.api);

  const iniTbDatas = {
    allLeavesCategories: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
    leaveDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickModal = () => {
    setModValues((prevs) => ({ ...prevs, isModOpen: true, cardType: "add" }));
  };

  const handleDelete = async (filter, endpoint) => {
    const handleConfirm = async () => {
      if (filter) {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: endpoint,
              queryParams: filter,
            })
          ).unwrap();

          console.log(response);

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getAllLeaveCategories();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
  };

  function getAllLeaveCategories() {
    dispatch(
      fetchLeaveCategoriesData({
        filters: {},
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllLeaveCategories();
  }, []);

  useEffect(() => {
    if (leaveCategories?.status && leaveCategories?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allLeavesCategories: leaveCategories.data || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allLeavesCategories: [],
      }));
    }
  }, [leaveCategories]);

  const leavesTbColumns = [
    {
      dataField: "name",
      text: "Leave Category",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "no_ofdays",
      text: "Max Leave Days(Monthly)",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.no_ofdays || 0} Day(S)</span>;
      },
    },
    {
      dataField: "days_before",
      text: "Apply Days Before",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.days_before || 0} Day(S)</span>;
      },
    },
    {
      dataField: "is_paid",
      text: "Paid Leave",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_paid ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "doc_required",
      text: "Document Required",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.doc_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "approval_required",
      text: "Approval Required",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.approval_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className={`actionBtn icon edit`}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "edit",
                rowData: row,
              }));
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#c71010",
                cursor: "pointer",
              }}
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            type="button"
            className={`actionBtn icon delete`}
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter, deleteLeaveCategory);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash3-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#c71010",
                cursor: "pointer",
              }}
            >
              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${
              modValues.cardType === "edit"
                ? "Edit New Leave category"
                : modValues.cardType === "add"
                ? "Add New Leave category"
                : ""
            } `}
            onClose={closeModal}
          />
          <AdminLeaveForm
            userInfoData={userInfoData}
            closeModal={closeModal}
            callFunction={() => getAllLeaveCategories()}
            rowData={modValues.rowData}
          />
        </div>
      </Modal>

      <br />

      <CommonStructured
        pageHeading={""}
        createBtnTxt={"+ Add New Leave Category"}
        createBtnTxt1={"Reload"}
        onClickCreateBtn={onClickModal}
        onClickCreateBtn1={() => getAllLeaveCategories()}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allLeavesCategories}
            tableColumns={leavesTbColumns}
          />
        )}
      </div>

      <div className="lead-logs-card-container leave-management-mobile-v only-mobile">
        <div className="all-leads-log mt30">
          {tbDatas.allLeavesCategories?.length > 0 &&
            tbDatas.allLeavesCategories.map((staff, index) => {
              return (
                <div className="log-card" key={index}>
                  <div className="all-info">
                    <div className="log-card-top">
                      <span className={`lead-type staff-leave-cat`}>
                        {staff?.name || "NA"}
                      </span>
                    </div>

                    <div
                      className="card-other-info"
                      style={{ padding: "10px 20px" }}
                    >
                      <span className="value semi-bold">
                        Max Leave Days :<b> {staff?.no_ofdays || 0}</b>
                      </span>

                      <span className="value semi-bold">
                        Apply Days Before :<b> {staff?.days_before || 0}</b>
                      </span>

                      <span className="value semi-bold">
                        Leave Paid :
                        <b>
                          {staff?.is_paid ? (
                            <CheckCircleIcon />
                          ) : (
                            <CrossCircleIcon />
                          )}
                        </b>
                      </span>

                      <span className="value semi-bold">
                        Document Required :
                        <b>
                          {" "}
                          {staff?.doc_required ? (
                            <CheckCircleIcon />
                          ) : (
                            <CrossCircleIcon />
                          )}
                        </b>
                      </span>

                      <span className="value semi-bold">
                        Approval Required :
                        <b>
                          {" "}
                          {staff?.approval_required ? (
                            <CheckCircleIcon />
                          ) : (
                            <CrossCircleIcon />
                          )}
                        </b>
                      </span>
                    </div>

                    <div className="all-followuo-info-container">
                      <div className="all-btns lead-btn-axceed">
                        <div className="lead-log-box">
                          <button
                            className="lead-log edit-btn"
                            onClick={() => {
                              setModValues((prevs) => ({
                                ...prevs,
                                isModOpen: true,
                                cardType: "edit",
                                rowData: staff,
                              }));
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil"
                              viewBox="0 0 16 16"
                              // style={{
                              //   width: "30px",
                              //   height: "30px",
                              // }}
                            >
                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                            </svg>
                          </button>

                          <span className="btn-label">Edit</span>
                        </div>

                        <div className="lead-log-box">
                          <button
                            className="lead-log delete-btn"
                            onClick={() => {
                              const uidFilter = {
                                uid: staff?.uid || "",
                              };
                              handleDelete(uidFilter, deleteLeaveCategory);
                            }}
                          >
                            {loading ? (
                              <Loader />
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-trash3-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                              </svg>
                            )}
                          </button>

                          <span className="btn-label">Delete</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default LeaveCategory;
